import { format } from "date-fns";
import { FC, memo } from "react";
import { Link } from "react-router-dom";
import { CopayCompletedClaimsType } from "src/pages/copayClaimsHCP/types";

const CompletedClaimsTableRow: FC<{ treatable: CopayCompletedClaimsType; refreshListing: () => void; }> = ({ treatable }): JSX.Element => {
      const formatDate = (date: string) => (date ? format(new Date(date), "MM/dd/yyyy") : "");
  
  return (
    <>
      <tr>
        <td className="text-center align-middle case-td">
          <Link
            to={{ pathname: `/cases/detail/${treatable.case_id}` }}
            className={`${'text-zilretta'} `}>
            {treatable.case_id}
          </Link>
        </td>
        <td className="text-center align-middle">
          {treatable.patient_name}
        </td>
        <td className="text-center align-middle">
          {treatable.product}
        </td>
        <td className="text-center align-middle">
          {treatable.submitting_practice}
        </td>
        <td className="text-center align-middle">
          {treatable.claim_status}
        </td>
        <td className="text-center align-middle">
          {treatable.paid_claim_amount}
        </td>
        <td className="text-center align-middle">
          {treatable && treatable.paid_claim_date ? formatDate(treatable.paid_claim_date) : ""}
        </td>
        <td className="text-center align-middle">
          {treatable.remaining_copay_available}
        </td>
      </tr>
    </>
  )
}

export default memo(CompletedClaimsTableRow);
